module.exports = __webpack_public_path__ + "img/20191012161828704.9a8cf02b.jpg";